import { Component, OnInit, inject } from "@angular/core";
import { SolverService } from "@app/services/rest/solver.service";
import { SolverInfo } from "@app/models/dto/solver-issue";
import { MatDialog } from "@angular/material/dialog";
import { SolverScoreDialogComponent } from "@app/view/planning/solver-status-widget/solver-score-dialog.component";
import { SolverStatus } from "@app/models/dto/solver-status.enum";
import { BendableLongScore } from "@app/models/dto/bendable-long-score";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatSuffix } from "@angular/material/form-field";

@Component({
  selector: "app-solver-status-widget",
  templateUrl: "./solver-status-widget.component.html",
  styleUrls: ["./solver-status-widget.component.css"],
  imports: [MatProgressSpinner, MatIconButton, MatIcon, MatSuffix]
})
export class SolverStatusWidgetComponent implements OnInit {
  protected solver = inject(SolverService);
  protected matDialog = inject(MatDialog);

  public solverInfo: SolverInfo;
  public stopped: boolean;
  public running: boolean;
  public lastScore: Partial<BendableLongScore>;
  public workingScoreIssues: boolean = false;

  ngOnInit() {
    this.refreshStatus();
    this.solver.updateStream.subscribe((value) => {
      this.solverInfo = value;
      this.stopped = this.solverInfo.status === SolverStatus.STOPPED;
      this.running = this.solverInfo.status === SolverStatus.RUNNING;
    });
    this.solver.workingStatusStream.subscribe((value) => {
      console.log("received working status update", value);
      if (value) {
        this.lastScore = value.score;
        this.workingScoreIssues =
          this.lastScore.hardScores[0] < 0 || this.lastScore.hardScores[1] < 0;
      }
    });
  }

  refreshStatus() {
    this.solver.status().then((solverStatus) => {
      console.log("Solver status refresh", solverStatus);
      this.solverInfo = solverStatus;

      this.stopped = this.solverInfo.status === SolverStatus.STOPPED;
      this.running = this.solverInfo.status === SolverStatus.RUNNING;
    });
  }

  onExplainBestScore() {
    // Open the dialog immediately so admins can always reach the dump / reload controls,
    // even when the solver is hung. The explain call is best-effort: if it fails or hangs,
    // the dialog stays open with whatever data the user needs to recover the solver.
    this.matDialog.open(SolverScoreDialogComponent, {
      width: "450px"
    });
    this.solver
      .explainBestScore()
      .then((value) => {
        console.log("explain score:");
        console.log(value);
      })
      .catch((err) => {
        console.warn("explainBestScore failed (solver may be hung):", err);
      });
  }
}
